@if (!(loading | async)) {
  <form [formGroup]="reportIncidentLocationForm" (ngSubmit)="submitClaimLocation()">
    <section formGroupName="location">
      <div class="row">
        <div class="column twelve pad-bottom-10">
          <h4
            class="heading-sub-section"
            dsContent
            [contentPath]="'claims.fnol.incidentSectionHeading'"
          ></h4>
        </div>
        <div class="column twelve md-five">
          <ds-form-control-container
            [labelText]="'City'"
            [control]="locationGroup.get('incidentCity')"
          >
            <input
              type="text"
              id="incidentCity"
              data-cy="incidentCity"
              class="fill"
              formControlName="incidentCity"
            />
            <ds-form-control-message
              [control]="locationGroup.get('incidentCity')"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
        <div class="column twelve md-five md-pad-horizontal-20">
          <ds-form-control-container
            [labelText]="'State'"
            [control]="locationGroup.get('incidentState')"
          >
            <select id="state" class="icon fill" data-cy="state" formControlName="incidentState">
              <option value=""></option>
              @for (state of usStates; track state) {
                <option [value]="state.value">
                  {{ state.name }}
                </option>
              }</select
            ><span class="icon-chevron-down"></span>
            <ds-form-control-message
              [control]="locationGroup.get('incidentState')"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
      </div>
      <div class="row">
        <div class="column twelve md-five">
          <ds-form-control-container
            [labelText]="'Location Type'"
            [control]="locationGroup.get('lossLocationType')"
          >
            <select id="paymentMethods" class="icon fill" formControlName="lossLocationType">
              <option value=""></option>
              @for (loc of lossLocationTypes; track loc) {
                <option [value]="loc.value">{{ loc.name }}</option>
              }</select
            ><span class="icon-chevron-down"></span>
          </ds-form-control-container>
          <ds-form-control-message
            [control]="locationGroup.get('lossLocationType')"
          ></ds-form-control-message>
        </div>
        <div class="column twelve pad-top-40 pad-bottom-10">
          <h4
            class="heading-sub-section"
            dsContent
            [contentPath]="'claims.fnol.anyOneHurtSelection'"
          ></h4>
        </div>
        <div class="column twelve">
          <fieldset class="radio">
            <div class="flex items-center">
              <input
                class="margin-right-6"
                type="radio"
                formControlName="lossInjuries"
                id="injuries-yes"
                [value]="'yes'"
              />
              <label for="injuries-yes" dsContent [contentPath]="'claims.fnol.yesInjuries'">
              </label>
            </div>
            <div class="flex items-center pad-top-10">
              <input
                class="margin-right-6"
                type="radio"
                formControlName="lossInjuries"
                id="injuries-no"
                [value]="'no'"
              />
              <label for="injuries-no" dsContent [contentPath]="'claims.fnol.noInjuries'"> </label>
            </div>
            <div class="flex items-center pad-top-10">
              <input
                class="margin-right-6"
                type="radio"
                formControlName="lossInjuries"
                id="injuries-unsure"
                [value]="'unsure'"
              />
              <label for="injuries-unsure" dsContent [contentPath]="'claims.fnol.notSure'"> </label>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row callToAction">
        <div class="column twelve">
          <a
            href="javascript:void(0)"
            (click)="goBackOneStep()"
            class="float-right md-float-left caption"
            ><i class="icon-chevron-left"></i> Back</a
          >
          <span class="md-float-right">
            <a
              class="pad-horizontal-20 caption"
              (click)="cancel()"
              dsContent
              [contentPath]="'shared.cancel'"
            ></a>
            <button ds-button type="submit" [disabled]="!reportIncidentLocationForm.valid">
              {{
                !!this.draftClaim && !!this.draftClaim?.fnolDetail?.typeOfLossLocationCode
                  ? 'Update'
                  : 'Save and Continue'
              }}
            </button>
          </span>
        </div>
      </div>
    </section>
  </form>
}
